import { TokenCategoryType } from './TokenCategoryType';

export const TokenCategoryTypeOptions = [
    {
        id: TokenCategoryType.Admin,
        name: 'Admin',
    },
    {
        id: TokenCategoryType.Broker,
        name: 'Broker',
    },
    {
        id: TokenCategoryType.Common,
        name: 'Common',
    },
    {
        id: TokenCategoryType.Borrower,
        name: 'Borrower',
    },
    {
        id: TokenCategoryType.Notices,
        name: 'Notices',
    },
    {
        id: TokenCategoryType.UserAgreement,
        name: 'User Agreements',
    },
];
